import { useMemo } from 'react';

export const useRandom = (min: number, max: number) =>
    useMemo(() => {
        const roundedMin = Math.ceil(min);
        const roundedMax = Math.floor(max);
        return Math.floor(Math.random() * (roundedMax - roundedMin)) + roundedMin;
    }, [min, max]);
